import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConflictsNav, ExpandedAdornment, ExpandedTable } from "@ryde/controls";
import {
  ConflictErrorSeverity,
  type GenericUploadRowConflictError,
} from "@ryde/shared";

import { GenericUploadPhoneConflictsContext } from "../../contexts";
import { PhoneConflictsTableRow } from "./phone-conflicts-table-row";

interface IPhoneConflictsTableProps {
  errorType: GenericUploadRowConflictError;
}

export const PhoneConflictsTable: FC<IPhoneConflictsTableProps> = ({
  errorType,
}) => {
  const { conflicts, skippedDataIndexes, onToggleSkippedRow } = useContext(
    GenericUploadPhoneConflictsContext,
  );
  const { t } = useTranslation();

  return (
    <ExpandedAdornment
      NavControl={
        <ConflictsNav
          title={t(`genericUpload.conflicts.${errorType}`)}
          severity={ConflictErrorSeverity.Critical}
          conflictNumber={conflicts.length}
        />
      }
    >
      <ExpandedTable dataE2E="phone-conflicts-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("genericUpload.phoneConflicts.skipRow")}</TableCell>
              <TableCell>{t("general.index")}</TableCell>
              <TableCell>
                {t("genericUpload.phoneConflicts.passenger")}
              </TableCell>
              <TableCell>{t("general.value")}</TableCell>
              <TableCell>{t("genericUpload.phoneConflicts.details")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts.map(conflict => (
              <PhoneConflictsTableRow
                key={`${conflict.errorType}_${conflict.dataIndex}`}
                conflict={conflict}
                isSkipped={skippedDataIndexes.includes(conflict.dataIndex)}
                onToggleSkippedRow={onToggleSkippedRow}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </ExpandedAdornment>
  );
};
